// import logo from 'vue-vtkjs-template/src/assets/logo.svg';
import Vue from 'vue'

// ----------------------------------------------------------------------------
// Component API
// ----------------------------------------------------------------------------


export default {
  data: () => ({
    girderServer: "http://fractsim.com:8080",
    firstName: '',
    lastName: '',
    email: '',
    text: 'Submit',
    done: false,
  }),
  name: 'App',
  components: {
  },
  computed: {

  },
  methods: {
    async onSubmitButtonClicked() {
      const info = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email
      }
      const file = new Blob([JSON.stringify(info)], {type: 'application/json'});

      var token = ''

      const res = await fetch('http://fractsim.com:8080/api/v1/api_key/token?key=B6NFdiBnOzqULX8gC9dX9QN7dEibRfQb4cwEb5NI',
      {
        method: 'post',
      })
      token = await res.json()

      var filename = new Date().valueOf();
      fetch("http://fractsim.com:8080/api/v1/file?parentType=folder&parentId=6344618678d3d1f6d6bac229&token=" + token['authToken'].token + "&name=" + filename + ".json&size=" + file.size, {
        method: 'post',
        body: file
      });

      this.text = "Submission Successful"
      this.done = true
    }

  },
  mounted() {

  },
};
